import React from 'react';

import type { MapInitialRegion } from '@helpers/Map';

type MapViewProps = {
  children?: React.ReactNode;
  initialRegion?: MapInitialRegion;
  region?: MapInitialRegion;
};

type MarkerProps = {
  children?: React.ReactNode;
};

export function isMapAvailable() {
  return false;
}

export default function MapView(_: MapViewProps) {
  return null;
}

export function Marker(_: MarkerProps) {
  return null;
}
